<template>
  <div class="popWrap">
    <div class="popup">
      <div class="popContain">
        <div class="popCont full">
          <div class="popHead">
            <h1 class="titH1">렌탈료 외 납부 내역</h1>
          </div>
          <div class="popBody full">
            <div class="popInner">
              <!-- 본문 (s) -->
              <section>
                <div class="titArea mt0" v-if="rentalOtherList.length == 0">
                  <h2 class="titH5">
                    <span class="inB normal">해당하는 납부 내역이 없습니다.</span>
                  </h2>
                </div>
                <div class="titArea mt0" v-if="rentalOtherList.length > 0">
                  <h2 class="titH5">
                    {{ productName }}
                    <span class="inB normal">(주문번호 : {{ orderId }})</span>
                  </h2>
                </div>
                <ul class="infoList statement">
                  <li v-for="(rentalOther, rentalOtherIndex) in rentalOtherList" :key="rentalOtherIndex">
                    <span class="item" v-text="getDatePattern(rentalOther.dt)"></span>
                    <span class="val">
                      <em v-text="getRentalOtherName(rentalOther.typ)"></em>
                      <!--<br />
                      <span class="desc">철거비/이전설치비</span>-->
                    </span>
                    <span class="money">
                      <em v-text="getConvertPrice(rentalOther.amt)"></em>
                      원
                    </span>
                  </li>
                </ul>
              </section>
              <!-- 본문 (e) -->
            </div>
          </div>
          <button type="button" class="btnIco_close" @click="close"><span>팝업 닫기</span></button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ApiService from '@/common/api.service';
import { convertPrice } from '@/common/common.filter';

export default {
  name: 'PaymentRentalOtherPop',
  props: ['orderId'],
  data: function() {
    return {
      rentalOtherList: [],
      dataLength: -1,
      productName: null,
    };
  },
  mounted() {
    ApiService.service('GET', '/service/auth/rental/other/info/' + this.orderId)
      .then(({ data }) => {
        if (data.isSucceed) {
          this.rentalOtherList = data.result.list;
          this.productName = data.result.productName;
          this.dataLength = this.rentalOtherList.length;
        }
      })
      .catch(({ response }) => {
        console.log(response);
      });
  },
  methods: {
    close: function() {
      this.$emit('close');
    },
    getDatePattern: function(date) {
      return date.substring(0, 4) + '-' + date.substring(4, 6) + '-' + date.substring(6, 8);
    },
    getRentalOtherName: function(typ) {
      let result = '';
      if (typ == 'OTAT0001') {
        result = '부품비';
      } else if (typ == 'OTAT0002') {
        result = '이전설치비';
      } else if (typ == 'OTAT0003') {
        result = 'AS비용';
      }
      return result;
    },
    getConvertPrice: function(amt) {
      return convertPrice(amt);
    },
  },
};
</script>
